import { render, staticRenderFns } from "./CoopUser.vue?vue&type=template&id=28f5eba1&scoped=true&"
import script from "./CoopUser.vue?vue&type=script&lang=js&"
export * from "./CoopUser.vue?vue&type=script&lang=js&"
import style0 from "./CoopUser.vue?vue&type=style&index=0&id=28f5eba1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f5eba1",
  null
  
)

export default component.exports